const FilterFunction = (e, items, items2, noData) => {
    let text = e;
    var text2 = text.toLowerCase();
    let trucks = items2;
    let filteredName = trucks.filter((item) => {
        return Object.keys(item).some(key => item[key].toString().toLowerCase().search(text2) !== -1);
    })
    if (!text || text === '') {
        items = items2;
    } else if (!Array.isArray(filteredName) && !filteredName.length) {
        noData = true;
    } else if (Array.isArray(filteredName)) {
        noData = false;
        items = filteredName;
    }
    return { items, noData }
}
export default FilterFunction